import React, { useCallback } from 'react'
import clsx from 'clsx'
import { sum } from 'ramda'

import formatter from 'services/formatter'

import { Table, TableCell, DescriptionText } from '@/components/index'
import * as SC from '../../styles'

export function BilledOrdersTable({ data }) {
  // ╦ ╦╔╦╗╦╦  ╔═╗
  // ║ ║ ║ ║║  ╚═╗
  // ╚═╝ ╩ ╩╩═╝╚═╝
  const getDetailPanel = ({ row: order, show }) => {
    if (!show) return null

    return (
      <>
        <SC.TableRow>
          <TableCell role="button" />
          <TableCell colSpan={2}>
            <DescriptionText
              label="TRANSPORTADORA:"
              value={order.transportadora}
            />
          </TableCell>
          <TableCell>
            <DescriptionText label="FATURAMENTO:" value={order.dsc_tipo} />
          </TableCell>
          <TableCell colSpan={2}>
            <DescriptionText label="EMISSÃO:" value={order.emissao} />
          </TableCell>
          <TableCell>
            <DescriptionText label="DT. RESERVA:" value={order.dtreserva} />
          </TableCell>
          <TableCell>
            <DescriptionText label="DT. ENTREGA:" value={order.dtentrega} />
          </TableCell>
          <TableCell colSpan={7} />
        </SC.TableRow>
      </>
    )
  }

  const displayTotal = useCallback(({ data, reportTitle }) => {
    const sumOf = (field) =>
      String(sum(data.map((order) => (order[field] ? order[field] : 0))))

    return (
      <>
        <SC.TableRow className="highlightText">
          <TableCell role="button" colSpan={1} />
          <TableCell colSpan={3} />
          <TableCell colSpan={2}>{reportTitle}</TableCell>

          <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
            {formatter(sumOf('qtdade_car')).toDecimal(2)} m²
          </TableCell>
          <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
            {formatter(sumOf('qtdade')).toDecimal(2)} m²
          </TableCell>
          <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
            R$ {formatter(sumOf('itped_prunit')).toDecimal(2)}
          </TableCell>
          <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
            R$ {formatter(sumOf('valor')).toDecimal(2)}
          </TableCell>
          <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
            {formatter(sumOf('prd_peso_bruto')).toDecimal(2)} Kg
          </TableCell>
          <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
            {formatter(sumOf('peso_brut_reserva')).toDecimal(2)} Kg
          </TableCell>
          <TableCell colSpan={3} />
        </SC.TableRow>
      </>
    )
  }, [])

  return (
    <Table
      groupBy="cod_pedido"
      size="medium"
      data={data}
      components={{
        Footer: displayTotal,
        GroupFooter: displayTotal,
      }}
      columns={[
        { title: 'PEDIDO', field: 'cod_pedido', align: 'left' },
        { title: 'REP', field: 'dsc_empresa', align: 'left' },
        { title: 'PRODUTO', field: 'dsc_abreviado', align: 'left' },
        { title: 'UN', field: 'dsc_un_medidas', align: 'left' },
        { title: 'REF', field: 'prd_referencia', align: 'left' },
        {
          title: 'QUANTIDADE RES.',
          field: 'qtdade_car',
          align: 'right',
          cellFormat: 'decimal',
        },
        {
          title: 'QUANTIDADE',
          field: 'qtdade',
          align: 'right',
          cellFormat: 'decimal',
        },
        {
          title: 'VALOR UNIT.',
          field: 'itped_prunit',
          align: 'right',
          cellFormat: 'decimal',
        },
        {
          title: 'VALOR',
          field: 'valor',
          align: 'right',
          cellFormat: 'decimal',
        },
        {
          title: 'P.BRUTO',
          field: 'prd_peso_bruto',
          align: 'right',
          cellFormat: 'decimal',
        },
        {
          title: 'P.BRUTO RES.',
          field: 'peso_brut_reserva',
          align: 'right',
        },
        { title: 'BLOQ.', field: 'dsc_bloq', align: 'left' },
        { title: 'STATUS', field: 'dsc_pedido', align: 'left' },
        { title: 'S.PEDIDO', field: 'ped_seupedido', align: 'right' },
      ]}
      detailPanel={getDetailPanel}
      detailPanelIcon={({ open, ...props }) => (
        <SC.DetailIcon className={clsx({ open })} {...props} />
      )}
    />
  )
}

export default React.memo(BilledOrdersTable)
